import { costRanges } from "./cost-ranges";

const uniqueStates = new Set();

Object.values(costRanges).forEach((entry) => {
  if (entry.state) {
    uniqueStates.add(entry.state);
  }
});

const supportedStates = Array.from(uniqueStates).sort();

export const isStateUnsupported = (state: string | undefined) => {
  return !state || !supportedStates.includes(state);
};
